import {
	SET_SINGLE_ATTENDEE,
	SET_ATTENDEE_METADATA,
	SET_ATTENDEE_AGENDA,
	SET_PUSH_ANNOUNCEMENT_TOKENS,
	UPDATE_ATTENDEE,
	UPDATE_ATTENDEE_METADATA,
	UPDATE_ATTENDEE_AGENDA_ITEM,
	DUPLICATE_ATTENDEE_AGENDA_ITEM,
	DELETE_ATTENDEE_AGENDA_ITEM,
	ADD_MANY_GROUPS_TO_ATTENDEE,
	REMOVE_MANY_GROUPS_FROM_ATTENDEE,
	CLEAR_ATTENDEE_DATA,
	SET_ATTENDEE_BADGES,
	UPDATE_BADGE,
} from '../actions/actionTypes';
import { parseAttendee, parseMetaDeta } from '@/redux/util/attendee.util';

const preState = {
	attendeeInfo: {},
	attendeeMetaData: {
		data: {},
		fields: [],
		attributes: [],
	},
	attendeeAgenda: [],
	pushAnnouncementTokens: [],
	badges: [],
};

const attendeeReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const {
		type,
		attendee,
		badge,
		eventAttendeeMetadata,
		attendeeAgenda,
		pushAnnouncementTokens,
		groups,
		metadata,
		agendaItem,
		agendaItemID,
		attendeeBadges,
	} = action;
	switch (type) {
		case SET_SINGLE_ATTENDEE:
			const attendeeInfo = parseAttendee(attendee);
			return { ...stateDup, attendeeInfo };
		case SET_ATTENDEE_METADATA:
			const { data, fields, attributes } = parseMetaDeta(eventAttendeeMetadata);
			return { ...stateDup, attendeeMetaData: { data, fields, attributes } };
		case SET_ATTENDEE_AGENDA:
			return { ...stateDup, attendeeAgenda };
		case SET_PUSH_ANNOUNCEMENT_TOKENS:
			return { ...stateDup, pushAnnouncementTokens };
		case CLEAR_ATTENDEE_DATA:
			return { ...preState };
		case UPDATE_ATTENDEE:
			stateDup.attendeeInfo = { ...stateDup.attendeeInfo, ...attendee };
			return { ...stateDup };
		case UPDATE_ATTENDEE_METADATA:
			stateDup.attendeeMetaData.data = JSON.parse(metadata);
			return { ...stateDup };
		case UPDATE_ATTENDEE_AGENDA_ITEM:
			stateDup.attendeeAgenda = stateDup.attendeeAgenda.map(item =>
				item.id === agendaItem.id ? { ...item, ...agendaItem } : item
			);
			return { ...stateDup };
		case DUPLICATE_ATTENDEE_AGENDA_ITEM:
			stateDup.attendeeAgenda.push(agendaItem);
			return { ...stateDup };
		case DELETE_ATTENDEE_AGENDA_ITEM:
			stateDup.attendeeAgenda = stateDup.attendeeAgenda.filter(item => item.id !== agendaItemID);
			return { ...stateDup };
		case ADD_MANY_GROUPS_TO_ATTENDEE:
			const oldGroups =
				stateDup.attendeeInfo && stateDup.attendeeInfo.groups ? stateDup.attendeeInfo.groups : [];
			const newGroupsAdded = [...oldGroups, ...groups];
			return { ...stateDup, attendeeInfo: { ...stateDup.attendeeInfo, groups: newGroupsAdded } };
		case REMOVE_MANY_GROUPS_FROM_ATTENDEE:
			const idsToRemove = groups.map(group => group.id);
			const previousGroups =
				stateDup.attendeeInfo && stateDup.attendeeInfo.groups ? stateDup.attendeeInfo.groups : [];
			const newGroupsRemoved = previousGroups.filter(group => !idsToRemove.includes(group.id));
			return { ...stateDup, attendeeInfo: { ...stateDup.attendeeInfo, groups: newGroupsRemoved } };
		case SET_ATTENDEE_BADGES:
			return { ...stateDup, badges: [...attendeeBadges] };
		case UPDATE_BADGE:
			// kudo_id is the kudo's id returned after updating a badge
			// id is the kudo's id in the initial query for all badges
			// after the redux store is updated, we need to make sure we are comparing the right values
			const updatedBadges = stateDup.badges.filter(b => (b.kudo_id || b.id) !== badge.kudo_id);
			if (updatedBadges.length === stateDup.badges.length) updatedBadges.push(badge);
			return { ...stateDup, badges: updatedBadges };
		default:
			return stateDup;
	}
};

export default attendeeReducer;
